import { render, staticRenderFns } from "./Devices.vue?vue&type=template&id=4cfcfb96&scoped=true"
import script from "./Devices.vue?vue&type=script&lang=ts"
export * from "./Devices.vue?vue&type=script&lang=ts"
import style0 from "./Devices.vue?vue&type=style&index=0&id=4cfcfb96&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfcfb96",
  null
  
)

export default component.exports